export enum TenantNameTypeShort {
    CUDD = "CUDD",
    TTS = "TTS",
    RPC = "RPC",
    GENERIC = "Portal",
}

export enum TenantNameTypeFull {
    CUDD = "CUDD Pressure Control",
    TTS = "Thru Tubing Solutions",
    RPC = "RPC",
    GENERIC = "Portal",
}

export enum TenantTitleType {
    CUDD = "CUDD Energy Services",
    TTS = "TTS Energy Services",
    RPC = "RPC Energy Services",
    GENERIC = "Portal",
}